import {
  BLUE_LIGHT,
  DELETE,
  OLD_BLUE,
  PRIMARY_BLACK,
} from "src/constants/colors";
import { Container, Row, RowIcon, RowLabel } from "./Menu.styles";
import { EraserIcon, PropertyEditIcon } from "src/assets/icons";

interface MenuProps {
  showCalendar: () => void;
  onSelect: () => void;
}

export const Menu = ({ showCalendar, onSelect }: MenuProps) => (
  <Container>
    <Row
      type="button"
      onClick={showCalendar}
      backgroundHoverColor={BLUE_LIGHT}
      defaultTextColor={PRIMARY_BLACK}
      hoverTextColor={OLD_BLUE}
    >
      <RowIcon>
        <PropertyEditIcon />
      </RowIcon>
      <RowLabel>Edit</RowLabel>
    </Row>
    <Row
      type="button"
      backgroundHoverColor={DELETE}
      defaultTextColor={DELETE}
      hoverTextColor={"rgb(255,255,255)"}
      onClick={onSelect}
    >
      <RowIcon>
        <EraserIcon />
      </RowIcon>
      <RowLabel>Remove</RowLabel>
    </Row>
  </Container>
);
